import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { AppBannerSetting, Severity } from 'models/denthub-settings';
import { denthubSettingsTemplate } from 'apollo/templates/organization';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

export const useBannerSettings = () => {
    const { t: translate } = useTranslation();
    const currentOrg = currentOrgVar();

    const [bannerSettings, setBannerSettings] = useState<AppBannerSetting[]>([]);

    useQuery(denthubSettingsTemplate, {
        onError: () => {
            setBannerSettings([
                {
                    title: translate('app-settings:DEFAULT_BANNER_TITLE'),
                    message: translate('app-settings:DEFAULT_BANNER_MESSAGE'),
                    severity: Severity.error,
                    isEnabled: true,
                },
            ]);
        },
        onCompleted: ({ denthubSettings }) => {
            const orgBanner =
                currentOrg.type === 'lab'
                    ? denthubSettings.labAppBanner
                    : currentOrg.type === 'clinic'
                      ? denthubSettings.clinicAppBanner
                      : null;
            setBannerSettings(orgBanner ? [orgBanner] : []);
        },
    });

    return { bannerSettings };
};
